import { Option, Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const RecordingReference = Schema.Struct({ workspaceId: Schema.String, recordingId: Schema.String });
export type RecordingReference = typeof RecordingReference.Type;
export const parseFlowRecordingRef = (raw: string | null | undefined): Option.Option<RecordingReference> => {
  if (!raw) return Option.none();
  const separator = raw.indexOf(":");
  if (separator <= 0 || separator >= raw.length - 1) return Option.none();
  return Option.some({ workspaceId: raw.slice(0, separator), recordingId: raw.slice(separator + 1) });
};
export class RecordingInitialLinkFailure extends privateDependencyFailure<RecordingInitialLinkFailure>()("RecordingInitialLinkFailure", "initial recording link") {}
export const recordingInitialLinkFailure = (cause: unknown) => new RecordingInitialLinkFailure({ cause: Redacted.make(cause) });
